import React, { type CSSProperties, useEffect, useState } from 'react';

import CPageModule from '../../components/CPageModule';
import { updateStateAttribute } from '../../helpers/helper';
import { useAppSelector } from '../../hooks/hooks';
import { useScroll } from '../../hooks/useScroll';

export interface StickyHeaderConfig {
  content: React.ReactNode;
  targetScrollProgress: number;
  pad?: boolean;
  style?: Pick<CSSProperties, 'padding' | 'paddingTop' | 'paddingBottom' | 'paddingLeft' | 'paddingRight'>;
}

interface StickyHeaderProps {
  config: StickyHeaderConfig;
}

interface State {
  targetProgressHit: boolean;
}

export default function StickyHeader(props: StickyHeaderProps) {
  const { dashboardOutletDimensions, headerDimensions } = useAppSelector((state) => state.dashboard);
  const scroll = useScroll();

  const [state, setState] = useState<State>({ targetProgressHit: false });

  useEffect(() => {
    updateStateAttribute<State>(
      {
        targetProgressHit: scroll.scrollY > props.config.targetScrollProgress - headerDimensions.h
      },
      setState
    );
  }, [scroll, props.config.targetScrollProgress, headerDimensions.h]);

  return (
    <div
      className={
        'shadow-md border-b fixed z-10 bg-white transition-[opacity,transform] duration-[400ms] ease-in-out will-change-[transform,opacity]'
      }
      style={{
        top: headerDimensions.h,
        left: dashboardOutletDimensions.left,
        width: dashboardOutletDimensions.w,
        transform: state.targetProgressHit ? 'translateY(0%)' : 'translateY(-100%)',
        opacity: state.targetProgressHit ? 1 : 0,
        willChange: 'transform, opacity',
        ...(props.config.style ?? {})
      }}
    >
      {props.config.pad ? (
        <CPageModule style={{ paddingBottom: 0, paddingTop: 0 }}>
          <div className={'py-2'}>{props.config.content}</div>
        </CPageModule>
      ) : (
        props.config.content
      )}
    </div>
  );
}
